//@ts-check
/**
 * @template T
 */
export class CacheHolder {
  /**
   * @param {number} [size]
   */
  constructor(size) {
    this._size = size;
    this._map = new Map();
    this._handler = [];
  }

  /**
   * @param {string|number} key 
   * @return {boolean}
   */
  has(key) {
    key = String(key);
    return this._map.has(key);
  }

  /** 
   * @param {string|number} key 
   * @return {T}
   */
  get(key) {
    key = String(key);
    return this._map.get(key);
  }

  /**
   * @param {string|number} key 
   * @param {T} value 
   */
  set(key, value) {
    key = String(key);
    const org = this._map.get(key);
    if (org == null && this._map.size === this._size) {
      const first = this._map.keys().next().value;
      this.delete(first);
    }
    this._map.set(key, value);
    if (org == null) {
      this.trigger('insert', key);
    }
  }

  /**
   * @param {string|number} key 
   */
  delete(key) {
    key = String(key);
    const deleted = this.get(key);
    this._map.delete(key);
    this.trigger('deleted', deleted);
  }

  /**
   * @return {string[]}
   */
  keys() {
    return [...this._map.keys()];
  }

  clear() {
    this._map.clear();
  }

  /**
   * @param {string} ev 
   * @param {Function} fn 
   */
  on(ev, fn) {
    this._handler[ev] = this._handler[ev] || [];
    this._handler[ev].push(fn);
  }

  /**
   * @param {string} ev 
   * @param  {...any} args 
   */
  trigger(ev, ...args) {
    const fns = this._handler[ev] || [];
    fns.forEach(fn => {
      fn(...args);
    });
  }
  
  /**
   * @param {string} ev 
   * @param {Function} fn 
   */
  off(ev, fn) {
    if (fn) {
      const fns = this._handler[ev];
      const index = fns.findIndex(f => fn === f);
      fns.splice(index, 1);
    } else {
      delete this._handler[ev];
    }
  }
}
